const API_ROOT = '/api/investors'

export const getUserInvestorUrl = () => `${API_ROOT}/user`
